<template>
  <b-container fluid>
  <div id="app">
    <div id="spinner" v-if="spinner">
      <grid-loader :loading="spinner" :color="$root.$data.spinnerColor" :size="$root.$data.spinnerSize"></grid-loader>
    </div>
  <div id="buttonOut" v-if="isLogin">
    <b-button variant="primary" size="sm" v-on:click="this.onLogout" :disabled="false">
      Выйти
    </b-button>
  </div>
    <router-view />
  </div>
  </b-container>
</template>

<script>
import GridLoader from 'vue-spinner/src/GridLoader.vue'

export default {
  name: 'App',
  components: {GridLoader},
  data () {
    return {}
  },
  methods: {
    onLogout: function (event) {
      this.$store.commit('logout')
      this.$router.push('login')
    }
  },
  computed: {
    spinner: {
      get () {
        return this.$store.state.spinner
      }
    },
    isLogin: {
      get () {
        return this.$store.state.isLogin
      }
    }
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#spinner {
  position: fixed;
  z-index:9999;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
#buttonOut {
  position: fixed;
  z-index:9999;
  top: 3%;
  right: 1%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue